/**
 * Item service API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CharacteristicRequest } from './characteristicRequest';
import { Sku } from './sku';


export interface Item { 
    mpId?: number;
    sellerItemId?: string;
    brandId?: number;
    regionId?: number;
    characteristics?: CharacteristicRequest;
    name?: string;
    description?: string;
    baseImageUrl?: string;
    extraImageUrls?: Array<string>;
    tax?: number;
    productType?: Item.ProductTypeEnum;
    status?: Item.StatusEnum;
    sku?: Array<Sku>;
}
export namespace Item {
    export type ProductTypeEnum = 'PHYSICAL' | 'DIGITAL' | 'FINANCIAL_ITEM' | 'TENDER' | 'DIGITAL_CALENDAR' | 'INTERVIEW';
    export const ProductTypeEnum = {
        PHYSICAL: 'PHYSICAL' as ProductTypeEnum,
        DIGITAL: 'DIGITAL' as ProductTypeEnum,
        FINANCIAL_ITEM: 'FINANCIAL_ITEM' as ProductTypeEnum,
        TENDER: 'TENDER' as ProductTypeEnum,
        DIGITAL_CALENDAR: 'DIGITAL_CALENDAR' as ProductTypeEnum,
        INTERVIEW: 'INTERVIEW' as ProductTypeEnum
    };
    export type StatusEnum = 'HIDDEN' | 'PUBLISHED' | 'DELETED';
    export const StatusEnum = {
        HIDDEN: 'HIDDEN' as StatusEnum,
        PUBLISHED: 'PUBLISHED' as StatusEnum,
        DELETED: 'DELETED' as StatusEnum
    };
}


